module.exports = __webpack_public_path__ + "img/slide-bar-off_05.0abcc389.png";